<template>
  <div id="dd-range-container">
    <div class="gray-container">
      <div class="dd-label">
        <div>From: </div>
      </div>
      <input
        v-model="localStartDate"
        class="dd-input"
        type="datetime-local"
        name="startDate"
        :max="max"
        @blur="updateStartDate"
      >
    </div>
    <div class="gray-container">
      <div class="dd-label">
        <div>To: </div>
      </div>
      <input
        v-model="localEndDate"
        class="dd-input"
        type="datetime-local"
        name="endDate"
        :min="localStartDate"
        :max="max"
        @blur="updateEndDate"
      >
    </div>
    <button
      type="button"
      class="filter-button"
      @click="getDeviceFilteredData"
    >
      <img
        v-if="loading"
        src="@shared/assets/img/general/loading-white.svg"
        alt="Loading"
        class="loader-img"
      >
      <span v-else>Apply</span>
    </button>
    <div class="gray-container">
      <button
        type="button"
        class="dd-input"
        @click="subTime('hours')"
      >
        -
      </button>
      <div class="sac__font-12 f-white bold dd-label">
        <div> Hourly </div>
      </div>
      <button
        type="button"
        class="dd-input"
        @click="addTime('hours')"
      >
        +
      </button>
    </div>
    <div class="gray-container">
      <button
        type="button"
        class="dd-input"
        @click="subTime('days')"
      >
        -
      </button>
      <div class="sac__font-12 f-white bold dd-label">
        <div> Daily </div>
      </div>
      <button
        type="button"
        class="dd-input"
        @click="addTime('days')"
      >
        +
      </button>
    </div>
    <div
      v-if="Object.keys(allSupplySerialCycles).length > 1 && !partnerView"
      class="gray-container"
    >
      <div class="sac__font-12 f-white bold dd-label">
        Zone
      </div>
      <SACDropdown
        dark
        field="selectedSupplySerial"
        :options="supplySerialOptions"
        :value="selectedSupplySerial"
        :change="changeDeviceDetailValue"
      />
    </div>
    <div v-if="!partnerView" class="gray-container">
      <button
        type="button"
        :class="[
          'sac__font-12 f-white bold dd-label',
          showOnlyValid ? 'active' : 'n100',
        ]"
        @click="changeDeviceDetailValue('showOnlyValid', !showOnlyValid)"
      >
        Valid Cycles
      </button>
    </div>
    <div v-if="!partnerView" :class="['gray-container']">
      <button
        type="button"
        :class="[
          'sac__font-12 f-white bold dd-label',
          showFwView ? 'active' : 'n100',
        ]"
        @click="changeDeviceDetailValue('showFwView', !showFwView)"
      >
        Fw View
      </button>
    </div>
    <div v-if="!partnerView" :class="['gray-container']">
      <button
        type="button"
        :class="[
          'sac__font-12 f-white bold dd-label cycle-toggle-btn',
          showCycle ? 'active' : 'n100',
        ]"
        @click="toggleCycles"
      >
        <i :class="showCycle ? 'fas fa-eye-slash' : 'fas fa-eye'" class="btn-icon"></i>
        {{ showCycle ? 'Hide Cycles' : 'Show Cycles' }}
      </button>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import deviceDetailMixin from '@shared/mixins/deviceDetailMixin';

export default {
  name: 'VisualizeFilter',
  components: {
    SACDropdown,
  },
  mixins: [deviceDetailMixin],
  props: {
    lightMode: Boolean,
  },
  data() {
    return {
      max: moment().format('YYYY-MM-DD HH:mm'),
      graphStartTime: null,
      graphEndTime: null,
      loading: false,
      localStartDate: '',
      localEndDate: '',
    };
  },
  computed: {
    showOnlyValid() {
      return this.$store.state.deviceDetail.showOnlyValid;
    },
    showFwView() {
      return this.$store.state.deviceDetail.showFwView;
    },
    showCycle() {
      return this.$store.state.deviceDetail.showCycle;
    },
    supplySerialOptions() {
      return Object.keys(this.allSupplySerialCycles).map((key) => ({
        label: key,
        value: key,
      }));
    },
  },
  watch: {
    startTime(newValue) {
      this.graphStartTime = newValue;
      this.updateLocalDates();
    },
    endTime(newValue) {
      this.graphEndTime = newValue;
      this.updateLocalDates();
    },
  },
  mounted() {
    if (this.startTime && this.endTime) {
      this.graphStartTime = this.startTime;
      this.graphEndTime = this.endTime;
    }
    this.updateLocalDates();
  },
  methods: {
    updateLocalDates() {
      if (this.graphStartTime) {
        this.localStartDate = moment(this.graphStartTime).format('YYYY-MM-DDTHH:mm');
      }
      if (this.graphEndTime) {
        this.localEndDate = moment(this.graphEndTime).format('YYYY-MM-DDTHH:mm');
      }
    },
    updateStartDate() {
      if (this.localStartDate) {
        this.graphStartTime = moment(this.localStartDate).utc(false).toISOString();
      }
    },
    updateEndDate() {
      if (this.localEndDate) {
        this.graphEndTime = moment(this.localEndDate).utc(false).toISOString();
      }
    },
    toggleCycles() {
      this.changeDeviceDetailValue('showCycle', !this.showCycle);
    },
    subTime(type) {
      const currentTime = this.localEndDate || moment().format('YYYY-MM-DDTHH:mm');
      this.localStartDate = moment(currentTime).subtract(2, type).format('YYYY-MM-DDTHH:mm');
      this.localEndDate = moment(currentTime).subtract(1, type).format('YYYY-MM-DDTHH:mm');
      this.updateStartDate();
      this.updateEndDate();
      this.getDeviceFilteredData();
    },
    addTime(type) {
      const currentTime = this.localEndDate || moment().format('YYYY-MM-DDTHH:mm');
      let disable;
      if (type === 'hours') {
        disable = moment().isSame(moment(currentTime), 'h');
      } else {
        disable = moment().isSame(moment(currentTime), 'd');
      }
      if (!disable) {
        this.localStartDate = moment(currentTime).format('YYYY-MM-DDTHH:mm');
        this.localEndDate = moment(currentTime).add(1, type).format('YYYY-MM-DDTHH:mm');
        this.updateStartDate();
        this.updateEndDate();
        this.getDeviceFilteredData();
      }
    },
    async getDeviceFilteredData() {
      this.loading = true;
      if (this.activeTab === 'chart') {
        const isQueryExist = this.$route.query.activeTab;
        if (isQueryExist) {
          this.$router.replace(`/device/${this.currentUid}`);
        }
      }
      if (this.graphStartTime && this.graphEndTime) {
        this.changeDeviceDetailValue('startTime', this.graphStartTime);
        this.changeDeviceDetailValue('endTime', this.graphEndTime);
      }
      await this.fetchData();
      this.loading = false;
    },
    changeDeviceDetailValue(field, value) {
      this.$store.dispatch('changeDeviceDetailValue', {
        key: field,
        value,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#dd-range-container {
  display: flex;
  position: relative;
  margin-bottom: 20px;
  .gray-container {
    background-color: var(--bg-color);
    color: var(--text-color);
    border-radius: 12px;
    display: grid;
    grid-auto-flow: column;
    margin-right: 20px;
    .dd-input {
      color: var(--text-color);
      padding: 4px 12px;
      color-scheme: dark;
    }
    .dd-label {
      background-color: var(--label-color);
      padding: 4px 12px;
      border-radius: 12px;
      display: grid;
      align-items: center;
      color: var(--text-color);
      font-size: 12px;
      font-weight: 500;
      &.active {
        cursor: pointer;
        background-color: $NBLUE110;
      }
    }
  }

  .sac-dropdown {
    background-color: $N100 !important;
    color: $WHITE;
    font-weight: 500;
  }

  .filter-button {
    padding: 4px 20px;
    color: $WHITE;
    margin-right: 20px;
    border-radius: 12px;
    background-color: $NBLUE110;
  }

  .cycle-toggle-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 6px;
    transition: all 0.2s ease;
    
    .btn-icon {
      font-size: 11px;
    }
    
    &.active {
      background-color: $NBLUE110;
      color: $WHITE;
      
      &:hover {
        background-color: lighten($NBLUE110, 10%);
      }
    }
    
    &:not(.active) {
      background-color: rgba(255, 255, 255, 0.1);
      color: rgba(255, 255, 255, 0.7);
      
      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
        color: $WHITE;
      }
    }
  }
}
</style>
